import React, { useEffect, useState } from "react";
import { Box, Pagination } from "@mui/material";

const CursorPagination = ({
  fetchFunction,
  basePayload = {},
  limit,
  dependency = [],
  onDataChange,
  responseMapper,
  onLoadingChange,

}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [cursorStack, setCursorStack] = useState([null]);
  const [totalCount, setTotalCount] = useState(0);

const fetchPage = async (cursor = null) => {
  try {
    onLoadingChange?.(true);

    const payload = {
      ...basePayload,
      limit,
    };

    if (cursor !== null && cursor !== undefined) {
      payload.after = cursor;
    }

    const response = await fetchFunction(payload);

    if (!response?.success && !response?.status) {
      return null;
    }

    const mapped = responseMapper(response);

    onDataChange?.(mapped.data);
    setTotalCount(mapped.totalCount || 0);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return mapped;
  } catch (error) {
    console.error("Pagination fetch error:", error);
    return null;
  } finally {
    onLoadingChange?.(false);
  }
};

  useEffect(() => {
    setCurrentPage(1);
    setCursorStack([null]);

    const load = async () => {
      await fetchPage(null);
    };

    load();
  }, dependency);


  const handlePageChange = async (_, targetPage) => {
    if (targetPage === currentPage) return;


    if (targetPage <= cursorStack.length) {
      const cursor =
        targetPage === 1
          ? null
          : cursorStack[targetPage - 2];

      setCurrentPage(targetPage);
      fetchPage(cursor);
      return;
    }

    let tempCursorStack = [...cursorStack];
    let latestCursor =
      cursorStack[cursorStack.length - 1];

    let fetchedPage = cursorStack.length;

    while (fetchedPage < targetPage) {
      const payload = {
        ...basePayload,
        limit,
      };

      if (latestCursor) {
        payload.after = latestCursor;
      }

      const response =
        await fetchFunction(payload);

      if (!response?.success && !response?.status) {
        return;
      }

      const mapped = responseMapper(response);

      latestCursor = mapped.endCursor;

      tempCursorStack.push(latestCursor);

      fetchedPage++;
    }

    setCursorStack(tempCursorStack);

    const finalCursor =
      targetPage === 1
        ? null
        : tempCursorStack[targetPage - 1];

    setCurrentPage(targetPage);

    fetchPage(finalCursor);
  };

  const totalPages = totalCount
    ? Math.max(1, Math.ceil(totalCount / limit))
    : currentPage;

  if (!fetchFunction || totalPages <= 1) return null;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 5,
        mb: 2,
      }}
    >
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        size="large"
        sx={{
          "& .MuiPagination-ul": {
            gap: 0,
          },

          "& .MuiPaginationItem-root": {
            fontWeight: 600,
            fontSize: "14px",
            minWidth: { xs: 30, sm: 38 },
            height: 38,
            borderRadius: "10px",
            transition: "all .2s ease",
          },

          "& .Mui-selected": {
            backgroundColor: "#002255 !important",
            color: "#fff",
          },

          "& .MuiPaginationItem-root:hover": {
            backgroundColor: "#f3f5f9",
          },
        }}
      />
    </Box>
  );
};

export default React.memo(CursorPagination);